/**
 * Legacy fallback for assets stored with sibling `clip.mp4`/`thumbnail.png`
 * object keys. Timeline lane covers resolve
 * `<video-filename>.thumbnail.png` from component assets before falling back
 * to this.
 */
export function deriveSiblingThumbnailUrl(clipSrc: string): string | null {
  try {
    const url = new URL(clipSrc);
    const key = url.searchParams.get("key");
    if (!key?.endsWith("/clip.mp4")) return null;
    url.searchParams.set("key", key.replace(/\/clip\.mp4$/, "/thumbnail.png"));
    return url.toString();
  } catch {
    return null;
  }
}
